/**
 * Kafel znaku — jedyne miejsce w aplikacji z zaokrąglonym rogiem (27% boku).
 * Celowo w szarości, nie w kolorze marki: brand-500 jest zarezerwowany dla rzeczy,
 * w które użytkownik ma kliknąć (CLAUDE.md §5).
 */
export function Mark({ rozmiar = 34 }: { rozmiar?: number }) {
  return (
    <span
      aria-hidden="true"
      style={{
        width: rozmiar,
        height: rozmiar,
        borderRadius: 'var(--radius-mark)',
        background: 'var(--n-900)',
        color: 'var(--surface)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        font: 'var(--text-h2)',
        letterSpacing: '-0.04em',
        flexShrink: 0,
      }}
    >
      K
    </span>
  );
}
